import React from 'react';
import './style.css';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Carousel from "react-bootstrap/Carousel";
import Button from 'components/Button/Button';
import { NavLink } from "react-router-dom";
// import { user_access_level, user_Status, user_Status_Ver } from "Api/Api";
import { local_routes } from 'utils/Routes';

import FollowButton from 'components/FollowButton/FollowButton';

class EventDetailsBanner extends React.Component {
    render() {
        //console.log("RENDER",this.props.event_info);
        const { ticketUrl, posterImg, carouselImage, headerLogo, eventName, eventDescription, eventType, eventOwner, eventUuid, eventSource, edit_event_link } = this.props;
        let manage_event_route = local_routes.manageevent;
        //if (eventSource === "channel") {
        //    manage_event_route = local_routes.managechannelevent;
        //}
        let tmp_edit_event_link = `${manage_event_route}/${eventUuid}/description`;
        if (edit_event_link) {
            tmp_edit_event_link = edit_event_link;
        }
        let posterImgUrl;
        if (posterImg !== undefined) {
            let url = posterImg;
            let array = url.split("/");
            posterImgUrl = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padtransparent_noborder_240x360/${array[5]}`
        }
        
        let private_indicator = '';
        if (this.props.event_info.public_status && this.props.event_info.public_status === 'super_private') {
            private_indicator = <span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> PRIVATE</span>        
        }
        
        return (
            <div>
                {/* Banner section starts */}
                {carouselImage.length > 0 ?
                    <Carousel fade={true} pause={'hover'} controls={false} indicators={false} interval={5000}>
                        {
                            carouselImage.map((img, i) => {
                                let url = img;
                                let array = url.split("/");
                                //const convImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_1200x400/${array[5]}`;
                                const convImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/1400x400/${array[5]}`;
                                return (
                                    <Carousel.Item key={i} className="fade-carousel" style={{ height: '100%' }}>
                                        <div className="events-banner event-banner-new" style={{ minHeight: '350px', backgroundImage: `url(${convImg})` }}>
                                            <div className="container">
                                                <div className="row">
                                                    <Col sm={12} md={12} lg={12}>
                                                        <Row className="align-items-center">
                                                            {
                                                                posterImgUrl &&
                                                                <Col md={4} lg={3} sm={12}>
                                                                    <div className="event-mb-data">
                                                                        <img src={posterImgUrl} alt="img" className='img-fluid' />
                                                                    </div>
                                                                </Col>
                                                            }
                                                            <Col md={8} lg={9} sm={12}>
                                                                <div className="events-header-data">
                                                                    {
                                                                        eventType === "night" &&
                                                                        <div>
                                                                            <img src={headerLogo} alt="logo-img" />
                                                                        </div>
                                                                    }
                                                                    <h1>{eventName}{private_indicator}</h1>
                                                                    <p>{eventDescription}</p>
                                                                    {
                                                                        ticketUrl !== null &&
                                                                        <a
                                                                            rel="noopener noreferrer"
                                                                            className="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket"
                                                                            href={ticketUrl} target="_blank"
                                                                        >
                                                                            Get Tickets!
                                                                        </a>
                                                                    }
                                                                    {
                                                                        (this.props.event_info.venue_info && this.props.event_info.venue_info.virtual_meeting_link && this.props.event_info.showJoinMeeting) &&
                                                                        <a
                                                                            rel="noopener noreferrer"
                                                                            className="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket"
                                                                            href={this.props.event_info.venue_info.virtual_meeting_link} target="_blank"
                                                                        >
                                                                            Join Meeting!
                                                                        </a>
                                                                    }

                                                                </div>
                                                            </Col>
                                                            <Col md={4} lg={3} className="align-self-end" style={{ textAlign: "right", paddingRight: "15px" }}>
                                                                { (this.props.show_edit_button && !this.props.team_public_event_flag) &&
                                                                    <NavLink to={{
                                                                        pathname: `${edit_event_link}`,
                                                                        data: {
                                                                            source: {
                                                                                //...selectedLocationData,
                                                                                //entity_type: 'locations',
                                                                                //entity_uuid: selectedLocationData.entity_uuid,
                                                                                referrer: this.props.referrer
                                                                            }
                                                                        }
                                                                    }}>
                                                                        <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                                                            Manage Event
                                                                        </Button>
                                                                    </NavLink>
                                                                }

                                                                    <FollowButton
                                                                        entity_info={{entity_type: 'events', ...this.props.event_info}}
                                                                        followed={this.props.followed}
                                                                    />
                                                                

                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </div>
                                            </div>
                                        </div>
                                    </Carousel.Item>
                                )
                            }
                            )
                        }
                    </Carousel>
                    :
                    <div className="events-banner event-banner-new" style={{ backgroundColor: "#343E48" }}>
                        <div className="container">
                            <div className="row">
                                <Col sm={12} md={12} lg={8}>
                                    <Row className="align-items-center">
                                        {/* event-cover */}
                                        {
                                            posterImgUrl &&
                                            <Col md={4} lg={3} sm={12}>
                                                <div className="event-mb-data">
                                                    <img src={posterImgUrl} alt="img" className='img-fluid' />
                                                </div>
                                            </Col>
                                        }
                                        <Col md={8} lg={8} sm={12}>
                                            <div className="events-header-data">
                                                {
                                                    eventType === "night" &&
                                                    <div>
                                                        <img src={headerLogo} alt="logo-img" />
                                                    </div>
                                                }
                                                <h1>{eventName}</h1>
                                                <p>{eventDescription}</p>
                                                {
                                                    ticketUrl !== null &&
                                                    <a rel="noopener noreferrer" className="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket" href={ticketUrl} target="_blank">Get Tickets!</a>
                                                }
                                                {
                                                    (this.props.event_info.venue_info && this.props.event_info.venue_info.virtual_meeting_link && this.props.event_info.showJoinMeeting) &&
                                                    <a
                                                        rel="noopener noreferrer"
                                                        className="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket"
                                                        href={this.props.event_info.venue_info.virtual_meeting_link} target="_blank"
                                                    >
                                                        Join Meeting!
                                                    </a>
                                                }
                                            </div>
                                        </Col>
                                        <Col md={5} lg={4} className="ml-auto">
                                            { (this.props.show_edit_button && !this.props.team_public_event_flag) &&
                                                <NavLink to={{
                                                    pathname: `${edit_event_link}`,
                                                    data: {
                                                        source: {
                                                            //...selectedLocationData,
                                                            //entity_type: 'locations',
                                                            //entity_uuid: selectedLocationData.entity_uuid,
                                                            referrer: this.props.referrer
                                                        }
                                                    }
                                                }}>
                                                    <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                                        Manage Event
                                                    </Button>
                                                </NavLink>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </div>
                    </div>
                }

                {/* Banner section Ends */}
            </div>
        );
    }
}

export default EventDetailsBanner;
